import React, { useEffect, useState, useRef } from 'react';
import { Typography, Paper, Grid } from '@material-ui/core';
import { connect } from "react-redux";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { DialogTitle, DialogContent, DialogActions } from '../../components/Dialog/Dialog';
import { useForm, Controller } from 'react-hook-form';
import InputAdornment from '@material-ui/core/InputAdornment';
import { addNewParty, getPartyList, emptyPartyList } from "../../../store/actions/tripActionCreator";
import { editParty } from "../../../store/actions/partiesActionCreator";
import { sendError, sendSucces } from "../../../utils/utils";
import * as logger from "../../../logger";
import { trackDwebEvent } from '../../analytics';
import { getPartyLedgerData } from '../../../store/actions/homeActionCreator';
import { TextField,DatePicker,Radios } from 'mui-rff';
import { Form } from 'react-final-form';
import AddIcon from '@material-ui/icons/Add';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { TickShield } from '../../../components/icons';
import { defaultPageNo,defaultPageSize } from '../../../paginationVariables';
import AmountInput from '../../components/Inputs/AmountInput';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import DateFnsUtils from '@date-io/date-fns';
import { replaceCommas } from '../../../utils/utils';
import { addNewExpense,getAllVehicleExpense,addNewTripExpense,addNewOfficeExpenseType } from '../../../store/actions/expensesActionCreators';
import { add } from 'date-fns';
const styles = makeStyles(theme => ({
  formRoot: {
    '& .MuiFormControl-root': {
      width: '100%',
      margin: '16px 0px'
    }
  },
  error: {
    color: 'red',
    marginBottom: 8
  },
  marginV2: {
    marginTop: 16
  },
  marginV3: {
    marginTop: 16,
    marginLeft:11
  },
  title: {
    color: '#9ea0a5',
    fontSize: 12
  },
  formHelperText: {
    color: '#9ea0a5',
    fontSize: 11,
    marginTop: 4,
  },
  marginV1: {
    marginTop: 6,
    width: '100%'
  },
  textV1: {
    marginTop: 6,
    width: '100%',
    "& .MuiOutlinedInput-input": {
      textTransform: 'capitalize',
    },
  },
  brV1: {
    borderRadius: 8
  },
  divFlex: {
    display: 'flex',
    alignItems: 'center',
    color: '#0033cc',
    marginTop: 20,
    letterSpacing: '0.02em',
    fontWeight: 300,
  },
  titleBullet: {
    borderRadius: "50%",
    backgroundColor: "lightgrey",
    fontSize: 8,
    color: "lightgrey",
    margin: "0px 6px",
    marginTop: -2
  },
  divAlign: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 20
  },
  addIcon: {
    marginTop: -2,
    fontSize: 15,
    cursor: 'pointer'
  },
  textV2: {
    marginLeft: 4,
    cursor: 'pointer'
  },
  disableCta: {
    padding: '9px 26px 11px 28px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    backgroundColor: '#efeff2',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#3e3f42',
    height: 36,
    textTransform: 'capitalize',
    letterSpacing: '0.02em'
  },
  saveCta: {
    padding: '9px 26px 11px 28px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    backgroundColor: '#0033cc',
    fontSize: 14,
    fontWeight: 300,
    color: 'white',
    height: 36,
    textTransform: 'capitalize',
    letterSpacing: '0.02em',
    '&:hover': {
      backgroundColor: '#0033cc',
    }
  },
  eventIcon: {
    color: 'grey'
  },
  typeRadio: {
      '& .MuiRadio-root': {
          color: '#6618b5'
      }
  }
}))

const AddNewExpense = (props) => {
  let submit;
  const { children, 
    user, 
    addType,
    defaultId, 
    defaultName, 
    defaultNumber,
    defaultOpeningBalance,
    dispatchAddNewTripExpense,
    dispatchAddNewOfficeExpense,
    defaultOpeningBalanceDate, dispatchAddNewExpense, dispatchGetExpenseListAction, dispatchEditExpense, classes, open, onClose, onSave, ...other } = props;
  const [dialogopen, setDialogOpen] = React.useState(open);
  const [expenseNameValue, setExpenseNameValue] = useState(defaultName ? defaultName : "");
  const [openingBalanceAmount, setOpeningBalanceAmount] = useState(defaultOpeningBalance && defaultOpeningBalance>0?defaultOpeningBalance:0);
  const [mobileNumberFlag, setMobileNumberFlag] = useState(defaultNumber ? true : false);
  const [dataFlag, setDataFlag] = useState(false);

  const inlineStyles = styles();

  const initialValues = {
    name: expenseNameValue ? expenseNameValue : defaultName,
    type: 'maintenance_book',
  }

  const { register, handleSubmit, control, errors } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      name: defaultName ? defaultName : '',
      mobile: defaultNumber ? defaultNumber : '',
    },
  });
  const handlePartySave = (e) => {
  }
  const handleClose = (status) => {
    onClose(false);
  };
  useEffect(() => {
    trackDwebEvent('Dweb Expense Create Initiated');
  }, [dialogopen]);

  const onSubmit = data => {

    let expenseNameArray = data.name.split(" ");
    let expenseNameCapitalize = [];

    if (expenseNameArray && expenseNameArray.length > 0) {
      expenseNameArray.forEach((value) => {
        if (value) {
          expenseNameCapitalize.push((value.charAt(0).toUpperCase()) + value.slice(1));
        }
      })
    }

    if (defaultId) {
      var data = {
        expense_type: expenseNameCapitalize && expenseNameCapitalize.length > 0 ? (expenseNameCapitalize.join(" ")).trim() : "",
        type:data.type
      }

      dispatchEditExpense(defaultId,
        data,
        (data) => {
          if (data && data.status && data.status.code && data.status.code == 200) {
            sendSucces("Expense Updated Successfully!")
            onClose(false);
            onSave(data.response && data.response.name ? data.response.name : '');
          }
        },
        () => {
          logger.log("Add Party Component", "Edit Party Failed");
        }
      )
    }
    else {
      let res = {
        expense_type: expenseNameCapitalize && expenseNameCapitalize.length > 0 ? (expenseNameCapitalize.join(" ")).trim() : "",
      }
      if(addType && addType=='tripExpense'){
        res.name= expenseNameCapitalize && expenseNameCapitalize.length > 0 ? (expenseNameCapitalize.join(" ")).trim() : "";
        res.type='ADDITION';
        dispatchAddNewTripExpense(
          res,
          (addResponse) => {
            if (addResponse && addResponse.status && addResponse.status.code && addResponse.status.code == 200) {
              setTimeout(() => {
                handleClose();
                sendSucces("Expense Type Added Successfully!")
                onSave(true, addResponse.response)
              }, 300)
            }
          },
          () => {
          }
        );
      }else if(addType && addType=='officeExpense'){
        res.expenseType= expenseNameCapitalize && expenseNameCapitalize.length > 0 ? (expenseNameCapitalize.join(" ")).trim() : "";
        dispatchAddNewOfficeExpense(
          res,
          (addResponse) => {
            if (addResponse && addResponse.status && addResponse.status.code && addResponse.status.code == 200) {
              setTimeout(() => {
                handleClose();
                sendSucces("Expense Type Added Successfully!")
                onSave(true, addResponse.response)
              }, 300)
            }
          },
          () => {
          }
        );
      }else{
        res.type=data.type;
        dispatchAddNewExpense(
          res,
          (addResponse) => {
            if (addResponse && addResponse.status && addResponse.status.code && addResponse.status.code == 200) {
              setTimeout(() => {
                handleClose();
                sendSucces("Expense Type Added Successfully!")
                onSave(true, addResponse.response)
              }, 300)
            }
          },
          () => {
          }
        );
      }
    }
  };
  const getFormFields = (values) => {
    return [
      {
        size: 12,
        visible: true,
        field: (
          <>
            <div>
              <div className={inlineStyles.title}>Expense Name*</div>
              <TextField
                placeholder="Enter Expense Name"
                name="name"
                variant="outlined"
                size="small"
                // onChange={(e) => handlePartyName(e.target.value)}
                fieldProps={{
                  parse: value => value && (value.trim()).length == 0 ? value.trim() : value
                }}
                // onChange={() => setDataFlag(true)}
                className={inlineStyles.textV1}
              />
            </div>
          </>
        ),
      },
      {
        size: 12,
        visible: addType && (addType=='tripExpense'|| addType=='officeExpense')?false:true,
        field: (
          <>
            <div>
              <div className={inlineStyles.title}>Expense Type*</div>
              <Radios
                name="type"
                data={[
                    { label: 'Maintenance', value: 'maintenance_book' },
                    { label: 'Driver & Other', value: 'other_expenses_book' }
                ]}
                radioGroupProps={{ row: true }}
                formControlProps={{
                    margin: 'none',
                    className: inlineStyles.typeRadio,
                    fullWidth: true
                }}
              />
            </div>
          </>
        ),
      }
    ]
  }

  const validate = values => {

    const errors = {}

    // let partyName = values.name ? /^[A-Za-z]+$/.test(values.name.replace(/\s+/g, '')) : "";
    let number = values.mobile ? /^[5-9]{1}[0-9]{9}$/.test(values.mobile.replace("-", "")) : "";

    if (values && !values.name) {
      errors.name = "Please enter valid name."
    }
    
    if (values && values.name) {
      setDataFlag(true);
    } else {
      setDataFlag(false);
    }

    return errors;

  }

  return (
    <div>
      <Dialog fullWidth={true}
        maxWidth='xs'
        onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-party-dialog-title" open={dialogopen}
        classes={{ paperScrollPaper: inlineStyles.brV1 }}
      >
        <DialogTitle id="add-party-dialog-title" onClose={handleClose}>
          {defaultId ?
            (
              <span>Edit Custom Expense</span>
            ) : (
              <span>Add Custom Expense</span>
            )
          }
        </DialogTitle>
        <DialogContent dividers>
          <Form
            onSubmit={onSubmit}
            keepDirtyOnReinitialize
            initialValues={initialValues}
            validate={validate}
            id="myForm"
            render={({ handleSubmit, form, submitting, pristine, values }) => {
              submit = handleSubmit
              return (
                <form onSubmit={handleSubmit} noValidate id="myForm">
                  <Grid container alignItems="flex-start">
                    {getFormFields(values).map((item, idx) => item.visible ? (
                      <Grid item xs={item.size} key={idx}>
                        {item.field}
                      </Grid>
                    ) : null)}
                  </Grid>
                </form>
              )
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
            Close
          </Button>
          <Button className={!dataFlag ? inlineStyles.disableCta : inlineStyles.saveCta} type="submit" variant="contained"
            // onClick={() => {
            //   document.getElementById('myForm')
            //     .dispatchEvent(new Event('submit', { cancelable: true }))
            // }}
            onClick={event => {
              submit(event)
            }}
            disabled={!dataFlag}
          >
            Save changes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchAddNewExpense: (request, onSuccess, onFailure) => dispatch(addNewExpense(request, onSuccess, onFailure)),
  dispatchAddNewTripExpense: (request, onSuccess, onFailure) => dispatch(addNewTripExpense(request, onSuccess, onFailure)),
  dispatchAddNewOfficeExpense: (request, onSuccess, onFailure) => dispatch(addNewOfficeExpenseType(request, onSuccess, onFailure)),
  dispatchGetPartyListAction: (data, onSuccess, onFailure) => dispatch(getAllVehicleExpense(onSuccess, onFailure)),
  dispatchEditExpense: (id, data, onSuccess, onFailure) => dispatch(editParty(id, data, onSuccess, onFailure)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddNewExpense);